"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NativeToolbarView", {
    enumerable: true,
    get: function() {
        return NativeToolbarView;
    }
});
const NativeToolbarView = ()=>null;

//# sourceMappingURL=native.js.map
